//
//
//
//

export default {
  name: "cascader-defaultValue-editor",
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};